<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:50:06
 * @Description: 认证记录 当前登录
-->
<template>
	<div>
		<div>
			<Head :title="$t('home.current_login.current')" :iconUrl="require('@/assets/images/certife/login_current.png')" />
			<List :pagination="false" addTitle="" ref="table" :loading="loading" :columns="columns" :isChecked="false" :dataSource="dataSource">
			</List>
		</div>

		<!-- 免登录 -->
		<div style="margin-top: 20px">
			<Head :title="$t('home.current_login.logon_free')" :iconUrl="require('@/assets/images/certife/login_free.png')" />
			<List
				:pagination="false"
				addTitle=""
				ref="tableFree"
				:loading="loadingFree"
				:columns="columns"
				:isChecked="false"
				:dataSource="dataSourceFree"
			>
			</List>
		</div>
	</div>
</template>

<script>
import Head from "../../compontents/Head";
import List from "@/components/public/list/ant";
import { commonAPI } from "@/apis";
export default {
	name: "current",
	components: { Head, List },

	data() {
		return {
			columns: [
				{ title: this.$t("base.table.ip"), dataIndex: "sourceIp", key: "sourceIp", align: "center" },
				{ title: this.$t("base.table.ip_location"), dataIndex: "ipLocation", key: "ipLocation", align: "center" },
				{ title: this.$t("home.current_login.columns.login_time"), dataIndex: "loginTime", key: "loginTime", align: "center" },
				{ title: this.$t("home.current_login.columns.browser"), dataIndex: "browser", key: "browser", align: "center" },
				// { title: "操作", dataIndex: "platform", key: "platform", align: "center" },
			],
			dataSource: [],
			dataSourceFree: [],
			loading: false,
			loadingFree: false,
		};
	},
	created() {
		this.getList();
		this.getListFree();
	},
	methods: {
		async getList() {
			this.loading = true;
			const { code, data } = await commonAPI.getAction("/access/session/fetch", { pageSize: 10, pageNumber: 1 });
			if (code == 0) {
				this.dataSource = data.rows || [];
			} else {
				this.dataSource = [];
			}
			this.loading = false;
		},
		async getListFree() {
			this.loadingFree = true;
			const { code, data } = await commonAPI.getAction("/historys/loginHistory/pageRemeberMe", { pageSize: 10, pageNumber: 1 });
			if (code == 0) {
				this.dataSourceFree = data.rows || [];
			} else {
				this.dataSource = [];
			}
			this.loadingFree = false;
		},
	},
};
</script>

<style lang="less" scoped></style>
